const isDemo = process.env.REACT_APP_THEME === 'demo';

const styles = (theme) => ({
  yesLabel: {
    height: isDemo ? '32px' : '35px',
    background: isDemo ? '#ecfdf5' : theme.palette.success.main,
    color: isDemo ? '#047857' : '#fff',
    fontWeight: isDemo ? 600 : undefined,
    fontSize: isDemo ? '0.8125rem' : undefined,
    textTransform: isDemo ? 'none' : undefined,
    borderRadius: isDemo ? 999 : undefined,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    '&:hover,&:focus': {
      background: isDemo ? '#ecfdf5' : theme.palette.success.main,
    },
  },
  noLabel: {
    height: isDemo ? '32px' : '35px',
    background: isDemo ? '#fff7ed' : '#DE8C8C',
    color: isDemo ? '#c2410c' : '#fff',
    fontWeight: isDemo ? 600 : undefined,
    fontSize: isDemo ? '0.8125rem' : undefined,
    textTransform: isDemo ? 'none' : undefined,
    borderRadius: isDemo ? 999 : undefined,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    '&:hover,&:focus': {
      background: isDemo ? '#fff7ed' : '#DE8C8C',
    },
  },
  dashLabel: {
    height: isDemo ? '32px' : '35px',
    background: isDemo ? '#f3f4f6' : '#ECECEC',
    color: isDemo ? '#9ca3af' : undefined,
    fontWeight: isDemo ? 600 : undefined,
    fontSize: isDemo ? '0.8125rem' : undefined,
    textTransform: isDemo ? 'none' : undefined,
    borderRadius: isDemo ? 999 : undefined,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
});

export default styles;
